import React from 'react';
import styles from './questionChecklist.module.css';
import OptionGroup from './optionGroup';

const DEFAULT_GROUP = "default";

const QuestionItem: React.FC<{
    question: any;
    options: any[];
    expanded: boolean;
    selected: number[] | undefined;
    onToggle: (questionId: number) => void;
    onExpand: (questionId: number) => void;
    handleOptionToggle: (questionId: number, optionId: number) => void;
    groupBy?: (option: any) => string;
    labelKey?: string;
}> = ({
    question,
    options,
    expanded,
    selected,
    onToggle,
    onExpand,
    handleOptionToggle,
    groupBy = (option) => option.Groups?.Name || DEFAULT_GROUP,
    labelKey = "Desc"
}) => {
    // Group options
    const grouped = options.reduce<Record<string, any[]>>((acc, option) => {
        const key = groupBy(option);
        if (!acc[key]) acc[key] = [];
        acc[key].push(option);
        return acc;
    }, {});

    return (
        <div>
            <div className={styles.questionItem}>
                <input
                    type="checkbox"
                    id={`question-${question.Id}`}
                    className={styles.questionCheckbox}
                    checked={!!selected}
                    onChange={() => onToggle(question.Id)}
                />
                <button
                    className={styles.toggleButton}
                    aria-expanded={expanded}
                    aria-controls={`options-${question.Id}`}
                    onClick={() => onExpand(question.Id)}
                >
                    {expanded ? '-' : '+'}
                </button>
                <label htmlFor={`question-${question.Id}`} className={styles.questionLabel}>
                    {question.Desc}
                </label>
            </div>
            {expanded && (
                <div className={styles.optionsContainer} id={`options-${question.Id}`}>
                    {Object.entries(grouped).map(([groupName, groupOptions]) => (
                        <div key={groupName} className={styles.optionsGroup}>
                            {groupName !== DEFAULT_GROUP && (
                                <div className={styles.groupNameTitle}>{groupName}</div>
                            )}
                            <OptionGroup
                                questionId={question.Id}
                                options={groupOptions}
                                selected={selected}
                                handleOptionToggle={handleOptionToggle}
                                labelKey={labelKey}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
export default QuestionItem;